import { render, staticRenderFns } from "./OrientacoesDeExecucao.vue?vue&type=template&id=8192d138&scoped=true"
import script from "./OrientacoesDeExecucao.vue?vue&type=script&lang=js"
export * from "./OrientacoesDeExecucao.vue?vue&type=script&lang=js"
import style0 from "./OrientacoesDeExecucao.vue?vue&type=style&index=0&id=8192d138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8192d138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VImg})
